/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllArtist } from 'services/admin'
import {
  setCurrentPage,
  setData,
  setLoading,
  setTotalItem,
  setTotalPage,
} from 'store/artist/artistSlice'
import { selectArtist } from 'store/artist/selectors'
import 'styles/pages/_whitelist-artis.scss'
import ArtistHeader from './header'
import ArtistData from './data'
import ArtistPagination from './pagination'

const AdminManageArtisRole = () => {
  const { pageSize, status, currentPage } = useSelector(selectArtist)
  const dispatch = useDispatch()

  async function getData(page: number, showLoading = true) {
    try {
      if (showLoading) dispatch(setLoading(true))

      const rest = await getAllArtist({ limit: pageSize, page, status }).catch(
        () => {}
      )
      if (!rest || !rest.data || !(rest.status >= 200 && rest.status <= 299))
        return

      dispatch(setCurrentPage(rest.data.currentPage))
      dispatch(setTotalPage(rest.data.totalPage))
      dispatch(setTotalItem(rest.data.total))
      dispatch(setData(rest.data.data))
    } catch (error: any) {
      console.log(error)
    } finally {
      dispatch(setLoading(false))
    }
  }

  useEffect(() => {
    getData(1)
  }, [status])

  return (
    <div className='wa__container'>
      <div className='wa__panel'>
        <ArtistHeader />

        <ArtistData updateData={() => getData(currentPage, false)} />

        <ArtistPagination
          onChange={(i) => {
            if (i !== currentPage) getData(i)
          }}
        />
      </div>
    </div>
  )
}

export default AdminManageArtisRole
